import type { PersonalizableNestedBlok } from '@/helper/personalization/resolvePersonalizedBlocks';

import type { PersonalizedSkeletonComponent } from './personalizedSkeletonTypes';
import RichTextPersonalizedSkeleton from './skeletons/RichTextPersonalizedSkeleton';
import TeaserPersonalizedSkeleton from './skeletons/TeaserPersonalizedSkeleton';

export type { PersonalizedSkeletonComponent, PersonalizedSkeletonProps } from './personalizedSkeletonTypes';

export const PERSONALIZED_CONTENT_REGISTRY = {
  component_teaser: { Skeleton: TeaserPersonalizedSkeleton },
  component_rich_text: { Skeleton: RichTextPersonalizedSkeleton },
} as const;

export type PersonalizableStoryblokComponent = keyof typeof PERSONALIZED_CONTENT_REGISTRY;

export function isPersonalizableComponent(component: string): component is PersonalizableStoryblokComponent {
  return component in PERSONALIZED_CONTENT_REGISTRY;
}

export function getPersonalizedSkeletonForBlok(blok: PersonalizableNestedBlok): PersonalizedSkeletonComponent {
  if (isPersonalizableComponent(blok.component)) {
    return PERSONALIZED_CONTENT_REGISTRY[blok.component].Skeleton;
  }
  return TeaserPersonalizedSkeleton;
}
